import sanitize from "sanitize-filename";
interface File {
  id: string;
  name: string;
}
export const sanitizeAndDedupDownloadNames = (
  files: File[],
  folderName?: string
): File[] => {
  const filesWithSanitizedNames = files.map((file) => {
    // Perform a first pass where we replace all diacritic (eg: `´ˆ¨) with an underscore
    // We need this here because on the next steps, diacritic characters will be removed.
    let sanitizedFileName = file.name.replace(/\p{Diacritic}+/gu, "_");

    // Replace accented characters by their non-accented version
    sanitizedFileName = sanitizedFileName
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "");

    // REMOVE trailing and tailing unwanted characters and slashes
    sanitizedFileName = sanitizedFileName.replace(/^[^a-zA-Z0-9.\-_]+/gu, "");
    sanitizedFileName = sanitizedFileName.replace(/[^a-zA-Z0-9.\-_]+$/gu, "");

    // REPLACE all unwanted characters
    sanitizedFileName = sanitizedFileName.replace(/[^a-zA-Z0-9._\-/]+/gu, "_");

    // Collapse successive slashes
    sanitizedFileName = sanitizedFileName.replace(/\/+/gu, "/");

    sanitizedFileName = sanitize(sanitizedFileName);
    return {
      ...file,
      name: sanitizedFileName,
    };
  });

  const extention = ".png";
  const filesWithDedupedNames: File[] = [];
  filesWithSanitizedNames.forEach((file) => {
    const name = file.name ?? "";
    let fullName =
      name.slice(0, 256 - (folderName ?? "").length - extention.length) +
      extention;
    let suffix = 1;
    while (filesWithDedupedNames.some((f) => f.name === fullName)) {
      fullName =
        name.slice(
          0,
          256 -
            (folderName ?? "").length -
            extention.length -
            suffix.toString().length -
            1
        ) + `_${suffix}.png`;
      suffix++;
    }
    filesWithDedupedNames.push({
      ...file,
      name: fullName,
    });
  });

  return filesWithDedupedNames;
};
